import React from "react";
import Picker from "@emoji-mart/react";
import {
    newChatBoxIcon,
    newChatBoxIcon2,
    newChatBoxIcon3,
    newChatBoxIcon4,
    newChatBoxIcon5,
    AddNameBlue,
    ImageBlue,
    GIFBlue,
    EmojiBlue,
    LinkBlue,
    newChatBoxIconRestricted3,
    newChatBoxIconRestricted5
} from "../../assets/svg-icon/index";
import Config from "../../config";
import { InboxChatboxInputCharCount } from "../../components/Inbox/index";
import { errorToaster } from "../../utils/loggerUtils";
import Giyf from "../../components/Giyf/Giyf";
import Link from "../../components/Link/Link";
import { maximumMediaSize } from "../../config/constants/MaximumMediaSize";
import {
    setImageLoadingStatus,
    getGiyf,
    getSuggestionGiyf,
    getMe,
    createShortenUrl
} from "../../redux/actions";
import { connect } from "react-redux";
import { MMSStatus } from "../../constant";
import CustomToolTip from "../Inbox/inboxChatboxInput/Tooptip";
import { ImageBox } from "../ImageBox/ImageBox";
import { cloneEvent, isDomainExist, validateUrl } from "../../utils/urlUtils";
const MAX_COUNT = 1000;
const hoverKeys = {
    AddNameHover: "AddNameHover",
    LinkHover: "LinkHover",
    PictureHover: "PictureHover",
    EmojiHover: "EmojiHover",
    GiyfHover: "GiyfHover"
};
class MessageBox extends React.Component {
    hashMaps = {};
    constructor(props) {
        super(props);
        this.state = {
            mediaUrl: props.mediaUrl || null,
            inputFocus: false,
            messageText: props.messageText || props.addDefualtText || "",
            textAreaRows: 1,
            showEmoji: false,
            mediaObject: null,
            showGiyf: false,
            showLinkBox: false,
            showAutoReplyContainer: false,
            defualtText: true,
            hoverEffect: {
                AddNameHover: false,
                LinkHover: false,
                PictureHover: false,
                EmojiHover: false,
                GiyfHover: false
            },
            getUserData: false
        };

        this.linkIconRef = React.createRef();
        this.giyfIconRef = React.createRef();
        this.linkRef = React.createRef();
        this.giyfRef = React.createRef();
    }
    getUserData = () => {
        this.props.getMe();
        this.setState({
            getUserData: false
        });
    };
    componentDidMount() {
        this.getUserData();
    }
    componentWillUnmount() {
        this.setState({
            getUserData: true
        });
    }
    /**
     * @author resource one
     * @desc reset the message box when data is saved
     */
    componentDidUpdate(prevProps) {
        if (prevProps.resetInput !== this.props.resetInput) {
            this.handleClearStateMessageBox();
        }
        if (this.state.getUserData) {
            this.getUserData();
        }
        if (this.props.addDefualtText && this.state.defualtText) {
            if (this.props.showAutoResponseHandle) {
                this.props.showAutoResponseHandle(this.props.addDefualtRequestReply);
            }
            this.setState({
                messageText: this.props.addDefualtText,
                defualtText: false,
                showAutoReplyContainer: this.props.addDefualtRequestReply,
                mediaUrl: this.props.mediaUrl
            });
        }
    }

    handleInputClick = (e) => {
        this.setState({ inputFocus: true });
        this.bindDocumentListener();
    };
    stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };
    bindDocumentListener = () => {
        if (document.getElementsByClassName("ReactModalPortal")[0]) {
            document
                .getElementsByClassName("ReactModalPortal")[0]
                .addEventListener("click", this.documentClick, false);
        } else {
            document.getElementById("root").addEventListener("click", this.documentClick, false);
        }
    };
    unbindDocumentListener = () => {
        if (document.getElementsByClassName("ReactModalPortal")[0]) {
            document
                .getElementsByClassName("ReactModalPortal")[0]
                .removeEventListener("click", this.documentClick, false);
        } else {
            document.getElementById("root").removeEventListener("click", this.documentClick, false);
        }
    };
    documentClick = (e) => {
        if (
            this.linkIconRef.current &&
            !this.linkIconRef.current.contains(e.target) &&
            this.linkRef.current &&
            !this.linkRef.current.contains(e.target)
        ) {
            this.setState({ showLinkBox: false });
        }
        if (
            this.giyfIconRef.current &&
            !this.giyfIconRef.current.contains(e.target) &&
            this.giyfRef.current &&
            !this.giyfRef.current.contains(e.target)
        ) {
            this.setState({ showGiyf: false });
        }
        this.setState({ inputFocus: false });
    };
    messageTextUrl = () => {
        // e.preventDefault();
        let textWords = this.state.messageText.split(" ");
        textWords = textWords.map((eachWord) => {
            let shouldUpdate = validateUrl(eachWord);
            if (shouldUpdate) {
                shouldUpdate = isDomainExist(eachWord);
            }
            if (shouldUpdate) {
                // REPLACE LOGIC
                let exist = this.hashMaps.hasOwnProperty(eachWord);
                if (!exist) {
                    this.handleShortenUrlClick(eachWord).then((res) => {
                        this.hashMaps[`${eachWord}`] = res;

                        // return res
                    });
                } else {
                    return this.hashMaps[`${eachWord}`];
                }
            }
            return eachWord;
        });

        let filteredValues = textWords.join(" ");
        this.setState({
            messageText: filteredValues
        });
        this.props.handleChange(null, filteredValues);
    };
    handleChange = async (e) => {
        e.preventDefault();
        const eventClone = cloneEvent(e);
        let textWords = eventClone.target.value.split(" ");
        textWords = textWords.map((eachWord) => {
            let shouldUpdate = validateUrl(eachWord);
            if (shouldUpdate) {
                shouldUpdate = isDomainExist(eachWord);
            }
            if (shouldUpdate) {
                // REPLACE LOGIC
                let exist = this.hashMaps.hasOwnProperty(eachWord);
                if (!exist) {
                    this.handleShortenUrlClick(eachWord).then((res) => {
                        this.hashMaps[`${eachWord}`] = res;
                        this.messageTextUrl();
                    });
                } else {
                    return this.hashMaps[`${eachWord}`];
                }
            }
            return eachWord;
        });

        let filteredValues = textWords.join(" ");
        this.setState({
            messageText: filteredValues
        });
        eventClone.target = { ...eventClone.target, value: filteredValues };
        this.props.handleChange(eventClone, filteredValues);
    };

    getShortURL = async (link) => {
        return await this.handleShortenUrlClick(link);
    };

    showEmojiPanel = (show) => {
        this.setState({ showEmoji: show });
        if (!this.state.inputFocus) {
            this.bindDocumentListener();
        }
    };

    handleEmojiSelect = (emoji) => {
        let { messageText } = this.state;
        if (messageText.length + 1 < MAX_COUNT) {
            messageText += ` ${emoji.native}`;
            this.setState({ messageText });
        }
        if (this.props.updateTextState) {
            this.props.updateTextState(messageText);
        }
    };

    handleInputKeyDown = (e) => {
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            this.handleMessageSend();
        } else if (e.keyCode === 13 && e.shiftKey) {
            if (this.state.textAreaRows < 2) {
                this.setState((state) => ({
                    textAreaRows: state.textAreaRows + 1
                }));
            }
        } else if (e.keyCode === 8) {
            this.setState({
                textAreaRows: 1
            });
        }
    };
    handleClearStateMessageBox = () => {
        this.setState({ messageText: "", textAreaRows: 1, showAutoReplyContainer: false });
        this.clearFileInput();
    };
    handleMessageSend = (e) => {
        e && e.preventDefault();
        let { messageText } = this.state;
        if (!!messageText.trim().length) {
            // messageText = messageText.replace(/\r?\n/g, " <br/> ");
            if (this.props.onMessageSend) {
                this.props.onMessageSend(messageText, this.state.mediaObject);
                this.setState({ messageText: "", textAreaRows: 1 });
                this.clearFileInput();
                this.props.setImageLoadingStatus(true);
            }
        } else {
            if (this.state.mediaObject !== null) {
                if (this.props.onMessageSend) {
                    this.props.onMessageSend(messageText, this.state.mediaObject);
                    this.setState({ messageText: "", textAreaRows: 1 });
                    this.clearFileInput();
                    this.props.setImageLoadingStatus(true);
                }
            }
        }
    };
    openImageDialog = () => {
        this.inputFileReference.click();
    };
    _handleImageChange = (e) => {
        e.preventDefault();
        if (e.target.files[0].size / 1000000 > maximumMediaSize) {
            errorToaster("file size shouldn't exceed 1MB");
            return;
        }
        let fileReader = new FileReader();
        fileReader.readAsDataURL(e.target.files[0]);
        this.props._handleImageChange({ type: "image", Obj: e.target.files[0] });
        this.setState({ mediaObject: { type: "image", Obj: e.target.files[0] }, mediaUrl: null });
    };
    updateMediaObjectGiyf = (Obj) => {
        this.props.updateMediaObjectGiyf(Obj);
        this.setState({ mediaObject: Obj, mediaUrl: null });
    };
    clearFileInput = () => {
        this.setState({
            mediaObject: null
        });
        this.props.clearFileInput();
        if (this.inputFileReference) {
            this.inputFileReference.value = null;
        }
    };
    clearFileInputAlreadyUploaded = () => {
        this.setState({
            mediaObject: null
        });
        this.props.clearMediaUrl();
        if (this.inputFileReference) {
            this.inputFileReference.value = null;
        }
    };
    openGiffDialog = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            showGiyf: !this.state.showGiyf
        });
        if (!this.state.inputFocus) {
            this.bindDocumentListener();
        }
    };

    openLinkDialog = () => {
        this.setState({
            showLinkBox: !this.state.showLinkBox
        });
        if (!this.state.inputFocus) {
            this.bindDocumentListener();
        }
    };
    addLinkInTextMessage = async (link) => {
        let messageText = await this.handleShortenUrlClick(link);
        if (messageText.length + 1 < MAX_COUNT) {
            this.setState({
                showLinkBox: false,
                messageText: this.state.messageText + messageText
            });
            if (this.props.updateTextState) {
                this.props.updateTextState(this.props.stringAppend ? this.state.messageText + messageText : messageText);
            }
        }
    };
    handleShortenUrlClick = (url) => {
        return new Promise((resolve, reject) => {
            this.props
                .createShortenUrl(url)
                .then((res) => {
                    // Don't uncomment this.
                    // let messageText = this.state.messageText;
                    let text = `${Config.env().SHORTEN_URL_DOMAIN}/url/${res.Code}`;
                    resolve(text);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    };
    toggleRequestReply = (e) => {
        const { showAutoReplyContainer } = this.state;
        this.setState({ showAutoReplyContainer: !showAutoReplyContainer });
        this.props.showAutoResponseHandle(!showAutoReplyContainer);
    };

    addFirstNameHandler = (e) => {
        const MESSAGE_MAX_LENGTH = MAX_COUNT;
        const { messageText } = this.state;
        let text = `${messageText} {{FirstName}}`;
        if (text.length < MESSAGE_MAX_LENGTH) {
            this.setState({ messageText: text });
        }
        if (this.props.updateTextState) {
            this.props.updateTextState(` {{FirstName}}`);
        }
    };
    onHoverEffect = (key, value) => {
        let hoverEffect = { ...this.state.hoverEffect };
        if (value) {
            Object.keys(hoverEffect).forEach((val) => {
                hoverEffect[val] = false;
            });
        }
        hoverEffect[`${key}`] = value;
        this.setState({
            hoverEffect
        });
    };
    render() {
        const { messageText, showEmoji, showAutoReplyContainer } = this.state;
        const { textAreaRows, showAutoResponseToggle } = this.props;
        return (
            <>
                <div className="inbox-chatbox-input-wrapper" onClick={this.handleInputClick}>
                    <div className="inbox-chatbox-input">
                        <textarea
                            placeholder="Type your message here…"
                            value={messageText}
                            maxLength={MAX_COUNT}
                            rows={textAreaRows}
                            onScroll={(e) => e.stopPropagation()}
                            onKeyDown={this.handleInputKeyDown}
                            onChange={this.handleChange}
                            className={"text-area-alignment"}
                        ></textarea>
                        <ImageBox
                            mediaObject={this.state.mediaObject}
                            isImageUploading={this.props.isImageUploading}
                            clearFileInput={this.clearFileInput}
                        />
                        <ImageBox
                            mediaUrl={this.props.mediaUrl}
                            isMediaUpdate={this.props.isMediaUpdate}
                            clearFileInput={this.clearFileInputAlreadyUploaded}
                        />
                    </div>
                </div>

                <div className="emojisection messagebox-emoji-section">
                    <ul>
                        <CustomToolTip text={"Personalization"}>
                            <li
                                className="tooltip"
                                onClick={this.addFirstNameHandler}
                                onMouseEnter={() =>
                                    this.onHoverEffect(hoverKeys.AddNameHover, true)
                                }
                                onMouseLeave={() =>
                                    this.onHoverEffect(hoverKeys.AddNameHover, false)
                                }
                            >
                                <img
                                    src={
                                        this.state.hoverEffect.AddNameHover
                                            ? AddNameBlue
                                            : newChatBoxIcon
                                    }
                                    className="img-fluid"
                                    alt="img"
                                    style={{ minWidth: "30px" }}
                                />
                            </li>
                        </CustomToolTip>
                        <CustomToolTip text={"Link"}>
                            <li
                                className="tooltip"
                                onClick={this.openLinkDialog}
                                ref={this.linkIconRef}
                                onMouseEnter={() => this.onHoverEffect(hoverKeys.LinkHover, true)}
                                onMouseLeave={() => this.onHoverEffect(hoverKeys.LinkHover, false)}
                            >
                                <div ref={this.linkRef} onClick={(e) => this.stopPropagation(e)}>
                                    <Link
                                        marginLeft={30}
                                        showLinkBox={this.state.showLinkBox}
                                        addLinkInText={this.addLinkInTextMessage}
                                    />
                                </div>
                                <img
                                    src={
                                        this.state.hoverEffect.LinkHover || this.state.showLinkBox
                                            ? LinkBlue
                                            : newChatBoxIcon2
                                    }
                                    className="img-fluid"
                                    alt="img"
                                    style={{ minWidth: "30px" }}
                                />
                            </li>
                        </CustomToolTip>

                        <CustomToolTip text={"Emojis"}>
                            <li
                                className="tooltip"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.showEmojiPanel(true);
                                }}
                                onMouseEnter={() => this.onHoverEffect(hoverKeys.EmojiHover, true)}
                                onMouseLeave={() => this.onHoverEffect(hoverKeys.EmojiHover, false)}
                            >
                                {showEmoji && (
                                    <div
                                        onClick={(e) => this.stopPropagation(e)}
                                        className="absolute z-10 bottom-0"
                                    >
                                        <Picker
                                            onEmojiSelect={this.handleEmojiSelect}
                                            set="apple"
                                            theme="light"
                                            onClickOutside={() => this.showEmojiPanel(false)}
                                        />
                                    </div>
                                )}
                                <img
                                    src={
                                        this.state.hoverEffect.EmojiHover || this.state.showEmoji
                                            ? EmojiBlue
                                            : newChatBoxIcon4
                                    }
                                    className="img-fluid"
                                    alt="img"
                                    style={{ minWidth: "30px" }}
                                />
                            </li>
                        </CustomToolTip>
                        {this.props.user &&
                        this.props.user.Company &&
                        this.props.user.Company.MMSStatus === MMSStatus.Yes ? (
                            <CustomToolTip text={"Image"}>
                                <li
                                    className="tooltip"
                                    onClick={this.openImageDialog}
                                    onMouseEnter={() =>
                                        this.onHoverEffect(hoverKeys.PictureHover, true)
                                    }
                                    onMouseLeave={() =>
                                        this.onHoverEffect(hoverKeys.PictureHover, false)
                                    }
                                >
                                    <input
                                        ref={(ref) => (this.inputFileReference = ref)}
                                        onChange={(e) => this._handleImageChange(e)}
                                        type="file"
                                        id="my_file"
                                        style={{ display: "none" }}
                                    />
                                    <img
                                        src={
                                            this.state.hoverEffect.PictureHover
                                                ? ImageBlue
                                                : newChatBoxIcon3
                                        }
                                        className="img-fluid"
                                        alt="img"
                                        style={{ minWidth: "30px" }}
                                    />
                                </li>{" "}
                            </CustomToolTip>
                        ) : (
                            <CustomToolTip text={"Upgrade your account to start sending images"}>
                                <li
                                    className="tooltip"
                                    onMouseEnter={() =>
                                        this.onHoverEffect(hoverKeys.PictureHover, true)
                                    }
                                    onMouseLeave={() =>
                                        this.onHoverEffect(hoverKeys.PictureHover, false)
                                    }
                                >
                                    <img
                                        src={newChatBoxIconRestricted3}
                                        className="img-fluid"
                                        style={{ minWidth: "30px" }}
                                        alt="img"
                                    />
                                </li>
                            </CustomToolTip>
                        )}
                        {this.props.user &&
                        this.props.user.Company &&
                        this.props.user.Company.MMSStatus === MMSStatus.Yes ? (
                            <CustomToolTip text={"GIFS"}>
                                <li
                                    className="tooltip"
                                    style={{ position: "relative" }}
                                    onClick={this.openGiffDialog}
                                    onMouseEnter={() =>
                                        this.onHoverEffect(hoverKeys.GiyfHover, true)
                                    }
                                    onMouseLeave={() =>
                                        this.onHoverEffect(hoverKeys.GiyfHover, false)
                                    }
                                >
                                    <div ref={this.giyfRef}>
                                        <Giyf
                                            showGiyf={this.state.showGiyf}
                                            getGiyf={this.props.getGiyf}
                                            getSuggestionGiyf={this.props.getSuggestionGiyf}
                                            updateMediaObj={this.updateMediaObjectGiyf}
                                            inputFileReference={this.inputFileReference}
                                            openGiffDialog={this.openGiffDialog}
                                            className={"gif-modal"}
                                        />
                                    </div>
                                    <img
                                        style={{ minWidth: "30px" }}
                                        src={
                                            this.state.hoverEffect.GiyfHover
                                                ? GIFBlue
                                                : newChatBoxIcon5
                                        }
                                        ref={this.giyfIconRef}
                                        className="img-fluid"
                                        alt="img"
                                    />
                                </li>{" "}
                            </CustomToolTip>
                        ) : (
                            <CustomToolTip text={"Upgrade your account to start sending GIFS"}>
                                <li
                                    className="tooltip"
                                    style={{ position: "relative" }}
                                    onMouseEnter={() =>
                                        this.onHoverEffect(hoverKeys.GiyfHover, true)
                                    }
                                    onMouseLeave={() =>
                                        this.onHoverEffect(hoverKeys.GiyfHover, false)
                                    }
                                >
                                    <img
                                        src={newChatBoxIconRestricted5}
                                        className="img-fluid"
                                        alt="img"
                                        style={{ minWidth: "30px" }}
                                    />
                                </li>
                            </CustomToolTip>
                        )}

                        <li className="width-120">
                            <InboxChatboxInputCharCount
                                charCount={messageText.length}
                                maxCount={MAX_COUNT}
                            />
                        </li>
                    </ul>
                    {showAutoResponseToggle ? (
                        <div className="request-reply-toggle">
                            <p style={{ color: showAutoReplyContainer ? "#3AAF50" : "#A7B9C5" }}>
                                {" "}
                                Request Reply{" "}
                            </p>
                            <div className="auto-reply-btn text-right">
                                <div className="toggleswitching">
                                    <input
                                        type="checkbox"
                                        id="toggleswitch100"
                                        className="togglecheckbox"
                                        checked={showAutoReplyContainer}
                                        onClick={this.toggleRequestReply}
                                    />
                                    <label
                                        htmlFor="toggleswitch100"
                                        className="toggleswitch "
                                    ></label>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        isImageUploading: state.chat.isImageUploading,
        user: state.auth.user
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setImageLoadingStatus: (status) => dispatch(setImageLoadingStatus(status)),
        getGiyf: (query, limit, offset) => dispatch(getGiyf(query, limit, offset)),
        getSuggestionGiyf: (query) => dispatch(getSuggestionGiyf(query)),
        createShortenUrl: (url) => dispatch(createShortenUrl(url)),
        getMe: () => dispatch(getMe())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MessageBox);
